import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { AuditLogEntryType } from 'shared';

import { useFetchAuditLogsQuery } from "../services/api/auditLogApi/auditLog";

export function useAuditLogs() {
  const { organisationId } = useParams();
  const [searchParams] = useSearchParams();

  const entityTypeRaw = searchParams.get(`entityType`);
  const entityType = entityTypeRaw && Object.values(AuditLogEntryType).includes(entityTypeRaw as AuditLogEntryType)
    ? entityTypeRaw as AuditLogEntryType
    : undefined;
  const entityId = searchParams.get(`entityId`) || undefined;

  const logsResult = useFetchAuditLogsQuery({
    organisationId,
    entityType,
    entityId,
  }, {
    skip: !organisationId,
    refetchOnMountOrArgChange: true,
  });

  return {
    ...logsResult,
    entityType,
    entityId,
  };
}
